import React from 'react';

class RowItemKetQuaXuLyThamNhung extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.soVu}</td>
        <td className='txt-center'>{data.soNguoi}</td>
        <td className='txt-center'>{data.taiSanThamNhungTongTien}</td>
        <td className='txt-center'>{data.taiSanThamNhungTien}</td>
        <td className='txt-center'>{data.taiSanThamNhungTaiSanKhac}</td>
        <td className='txt-center'>{data.taiSanThamNhungDat}</td>
        <td className='txt-center'>{data.kienNghiThuHoiTongTien}</td>
        <td className='txt-center'>{data.kienNghiThuHoiTien}</td>
        <td className='txt-center'>{data.kienNghiThuHoiTaiSanKhac}</td>
        <td className='txt-center'>{data.kienNghiThuHoiDat}</td>
        <td className='txt-center'>{data.daThuTongTien}</td>
        <td className='txt-center'>{data.daThuTien}</td>
        <td className='txt-center'>{data.daThuTaiSanKhac}</td>
        <td className='txt-center'>{data.daThuDat}</td>
        <td className='txt-center'>{data.hanhChinhToChuc}</td>
        <td className='txt-center'>{data.hanhChinhCaNhan}</td>
        <td className='txt-center'>{data.chuyenCoQuanDieuTraVu}</td>
        <td className='txt-center'>{data.chuyenCoQuanDieuTraDoiTuong}</td>
        <td className='txt-center'>{data.daXuLyHanhChinhToChuc}</td>
        <td className='txt-center'>{data.daXuLyHanhChinhCaNhan}</td>
        <td className='txt-center'>{data.daKhoiToVu}</td>
        <td className='txt-center'>{data.daKhoiToDoiTuong}</td>
        <td className='txt-center'>{data.xuLyTrachNhiemNguoiDungDauKienNghi}</td>
        <td className='txt-center'>{data.xuLyTrachNhiemNguoiDungDauDaXuLy}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemKetQuaXuLyThamNhung;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemKetQuaXuLyThamNhung.jsx